import { useCallback, useEffect, useRef, useState } from "react";
import { SKELETON_DELAY_MS } from "../lib/adminPagination";

export default function usePagedListUi({
  currentPage,
  setCurrentPage,
  loading = false,
  scrollTargetRef,
  resetKey,
} = {}) {
  const [showSkeleton, setShowSkeleton] = useState(false);
  const previousPageRef = useRef(currentPage);

  useEffect(() => {
    if (!loading) {
      setShowSkeleton(false);
      return undefined;
    }
    const timer = window.setTimeout(() => setShowSkeleton(true), SKELETON_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [loading]);

  const goToPage = useCallback(
    (nextPage) => {
      const page = Math.max(1, Number(nextPage) || 1);
      setCurrentPage(page);
      const target = scrollTargetRef?.current;
      if (target && typeof target.scrollIntoView === "function") {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      } else if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    [scrollTargetRef, setCurrentPage]
  );

  useEffect(() => {
    if (previousPageRef.current === currentPage) return;
    previousPageRef.current = currentPage;
  }, [currentPage]);

  useEffect(() => {
    if (resetKey === undefined) return;
    setCurrentPage(1);
  }, [resetKey, setCurrentPage]);

  return { showSkeleton, goToPage };
}
